class PageStateStore {
  constructor() {
    this.state = {};
  }

  setState(page, data) {
    this.state[page] = {
      ...(this.state[page] || {}),
      ...data
    };
  }

  getState(page) {
    return this.state[page];
  }

  clearState(page) {
    delete this.state[page];
  }
}

export const pageStateStore = new PageStateStore(); 